import ResponseDownloadFilterNq from './SelectionFiltersModelNq'
function MySavedFilterNq() {
    return {
        id: null,
        name: null,
        selectionFilters: ResponseDownloadFilterNq()
      }
}
export default MySavedFilterNq;